import {MEETING_STATUS_CANCELLED, MEETING_STATUS_CONFIRMED, MEETING_STATUS_PENDING} from '../constants';
import {isMeetingCancelled} from '../filters/isMeetingCancelled';
import {isMeetingConfirmed} from '../filters/isMeetingConfirmed';

export function getMeetingState(meeting) {
    if (isMeetingCancelled(meeting)) {
        return MEETING_STATUS_CANCELLED;
    } else if (isMeetingConfirmed(meeting)) {
        return MEETING_STATUS_CONFIRMED;
    } else {
        return MEETING_STATUS_PENDING;
    }
}
